export default __webpack_public_path__ + "static/media/react.a5ce414f.svg";